export class GoTo {
  public static login() {
    const { pathname: curr } = window.location
    window.location.href = `${window.location.origin}/login?goto=${curr}`
  }
}
